import React from 'react';
import './style.scss';
import ContentContainer from './ContentContainer';
import Cards from '../../../../components/molecules/cards';
import dummyClientById from './clientById.json';

interface Props {
    data: typeof dummyClientById.vendingMachines;
}

function RenderVendingMachine(props: Props) {
  const { data } = props;
  return (
    <ContentContainer
      title="Vending Machine"
      haveButton={false}
    >
      <div className="row">
        {data.map((vm) => (
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-2" key={vm.id}>
            <Cards.Vending
              id={vm.id.toString()}
              title={vm.nickName}
              deviceId={vm.deviceId}
              location={vm.location}
              configuration="-"
            />
          </div>
        ))}
      </div>
    </ContentContainer>
  );
}

export default RenderVendingMachine;
